<template>
  <div class="teas-prefileiframe-page">
    <DsfMobileNavBar
      :navTitle="title"
      class="prefileiframe-head"
    ></DsfMobileNavBar>
    <iframe class="prefileiframe-content" :src="url"></iframe>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasPreFileIframe",
  ctrlCaption: "预览页面",
  mixins: [$mixins.control],
  design: {
    isMask: false,
  },
  data() {
    return {
      url: "",
      title: "",
    };
  },
  created() {
    this.url = this.$route.query.src
      ? this.$route.query.src
      : this.$route.params.src;
  },
  mounted() {
    this.title = this.$route.query.titleName
      ? this.$route.query.titleName
      : this.$route.params.titleName;
    this.title = this.title || "";
    if (this.title.length == 0) {
      this.title = this.title || "预览";
    }
    document.title = this.title;
  },
  methods: {},
});
</script>
